<template>
  <v-dialog
    v-model="notify.dialog"
    max-width="45%"
    scrollable
    @keydown.esc="$emit('input', false)"
  >
    <v-card>
      <vue-card-title
        :title="notify.heading"
        :subtitle="
          notify.subheading ||
            'You are about to delete data. Confirm your action.'
        "
        :icon="$getIcon('mdiFileDocumentEdit')"
        closable
        @close="notify.dialog = false"
      ></vue-card-title>
      <v-card-text class="pa-3">
        <div v-text="notify.text"></div>
        <slot></slot>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('close')" v-text="'Cancel'"></v-btn>
        <v-btn
          text
          color="primary"
          @click="$emit('agree')"
          v-text="'Yes'"
        ></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  components: {},
  props: {
    notify: {
      type: Object,
      required: true
    }
  }
};
</script>
